<template>
    <div>
        <div v-show="!mostrarDetalheFaseContrato">
            <b-alert show>
                <span>
                    Total do Contrato:
                    <strong>
                        {{ contrato.nuValorGlobalContrato | currency }}
                    </strong>
                </span>
                <br />
                <span>
                    Total das Fases:
                    <strong>{{ contrato.totalFases | currency }}</strong>
                </span>
                <br />
                <span>
                    Sem Registro:
                    <strong>
                        {{ contrato.valorDisponivelFases | currency }}
                    </strong>
                </span>
                <br />
            </b-alert>
            <app-tabela
                :itens="contrato.fasesContrato"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
                <template slot="acoes" slot-scope="data">
                    <span
                        class="text-primary"
                        v-if="mostrarBtnDetalharFase(data)"
                    >
                        <i
                            class="fa fa-info-circle fa-lg icon-button"
                            title="Detalhar Fase"
                            @click.stop="
                                detalharFaseContrato(data.faseContratoId)
                            "
                        ></i>
                    </span>
                </template>
                <template slot="requerAprovacao" slot-scope="data">
                    <app-status
                        :status="data.requerAprovacao ? 'SIM' : 'NÃO'"
                    ></app-status>
                </template>
                <template slot="valor" slot-scope="data">
                    <p class="text-right m-0">{{ data.valor | currency }}</p>
                </template>
                <template slot="saldo" slot-scope="data">
                    <p class="text-right m-0">{{ data.saldo | currency }}</p>
                </template>
                <template slot="disponivel" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.disponivel | currency }}
                    </p>
                </template>
            </app-tabela>
        </div>
        <div v-if="mostrarDetalheFaseContrato">
            <detalhes-fase-contrato
                :faseContrato="faseContrato"
                :contrato="contrato"
                :dataServicos="dataServicos"
                @fecharDetalhesFaseContrato="faseContrato = null"
            ></detalhes-fase-contrato>
        </div>
    </div>
</template>

<script>
import DetalhesFaseContrato from './DetalhesFaseContrato'

export default {
    components: {
        DetalhesFaseContrato
    },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        },

        dataServicos: {
            type: Object
        }
    },

    data() {
        return {
            faseContrato: null,
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'tipoFaseContrato',
                    label: 'Tipo da Fase',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'dataInicioVigencia',
                    label: 'Vigência Início',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'dataFimVigencia',
                    label: 'Vigência Fim',
                    sortable: true,
                    type: 'date',
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'requerAprovacao',
                    label: 'Requer Aprovação',
                    sortable: true,
                    filterable: true,
                    tdClass: 'text-nowrap text-center'
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'saldo',
                    label: 'Saldo',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'disponivel',
                    label: 'Sem Registro',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'itemContrato',
                    label: 'Item Contrato',
                    filterable: true,
                    sortable: true
                }
            ],
            itensPorPagina: 5
        }
    },
    methods: {
        mostrarBtnDetalharFase(fase) {
            return (
                fase.tipoFaseContratoId === 1 || fase.tipoFaseContratoId === 2
            )
        },

        detalharFaseContrato(faseContratoId) {
            this.faseContrato = this.contrato.fasesContrato.filter((item) => {
                return item.faseContratoId === faseContratoId
            })[0]
        }
    },

    created() {},

    computed: {
        mostrarDetalheFaseContrato() {
            return this.faseContrato !== null
        }
    }
}
</script>
